var bookingApp = angular.module('bookingApp', ['ngRoute', 'ngAnimate', 'session', 'property', 'ngSanitize', 'ngTouch', 'cart', 'httpModule','bfCarousel','extrasModule','ngMaterial', 'ngMessages']);

bookingApp.config(['$provide', function($provide){
    $provide.decorator('$locale', ['$delegate', function($delegate){
        if($delegate.id === 'en-us'){
            $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = '-\u00A4';
            $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = '';
        }
        return $delegate;
    }])
}]);
/**
 * Function use to serialise angular json object
 * @param data
 * @returns {string}
 */
serializeData = function (data) {
    // If this is not an object, defer to native string.
    if (!angular.isObject(data)) {
        return ( ( data == null ) ? '' : data.toString() );
    }

    var buffer = [], source = '';
    // Serialize each key in the object.
    for (var name in data) {
        if (!data.hasOwnProperty(name)) {
            continue;
        }
        var value = data[name];

        if (typeof value === 'object') {
            source += serializeData(value);
        } else {
            buffer.push(
                encodeURIComponent(name) +
                '=' +
                encodeURIComponent(( value == null ) ? '' : value)
            );
        }
    }
    // Serialize the buffer and clean it up for transportation.
    source += buffer
        .join('&')
        .replace(/%20/g, '+')
    ;

    return ( source );
};
// setup routes
bookingApp.config(function ($routeProvider, $provide) {
    $provide.decorator('$exceptionHandler',
        ['$delegate', function ($delegate) {
            return function (exception, cause) {
                $delegate(exception, cause);

                // noinspection JSForgottenDebugStatementInspection
                console.log('%c ******************************************','background: #ffdddd; color: red; font-weight:bold;');
                // noinspection JSForgottenDebugStatementInspection
                console.log(exception, cause);
                // noinspection JSForgottenDebugStatementInspection
                console.log('%c ******************************************','background: #ffdddd; color: red; font-weight:bold;');

                 if (typeof sentryDSN !== 'undefined') {
                     if (!Raven.isSetup()) {
                         Raven.config(sentryDSN).install();
                     }
                     // add required fields E.g. template id, session id, etc.
                     Raven.captureException(exception);
                 }

            };
        }]);
    $routeProvider
        .when('/', {
            title: 'Booking Process - Filter',
            controller: 'filterController',
            templateUrl: '/front-booking/mobile-views/filters?device=mobile'
        })
        .when('/rooms', {
            title: 'Booking Process - Room List',
            controller: 'roomsListController',
            templateUrl: '/front-booking/mobile-views/rooms?device=mobile'
        })
        .when('/room/:id', {
            title: 'Booking Process - Room',
            controller: 'roomController',
            templateUrl: '/front-booking/mobile-views/room?device=mobile'
        })
        .when('/extras', {
            title: 'Booking Process - Extra List',
            controller: 'extrasListController',
            templateUrl: '/front-booking/mobile-views/extras?device=mobile'
        })
        .when('/extras/room/:roomId', {
            title: 'Booking Process - Room / Extra',
            controller: 'extrasListController',
            templateUrl: '/front-booking/mobile-views/extras?device=mobile'
        })
        .when('/category/:categoryId/extra/:extraId', {
            title: 'Booking Process - Extra',
            controller: 'extraController',
            templateUrl: '/front-booking/mobile-views/extra?device=mobile'
        })
        .when('/cart', {
            title: 'Booking Process - Cart',
            controller: 'cartController',
            templateUrl: '/front-booking/mobile-views/cart?device=mobile'
        })
        .when('/lead-guest', {
            title: 'Booking Process - Lead Guest',
            controller: 'leadGuestController',
            templateUrl: '/front-booking/mobile-views/lead-guest?device=mobile'
        })
        .when('/payment', {
            title: 'Booking Process - Payment',
            controller: 'paymentController',
            templateUrl: '/front-booking/mobile-views/payment?device=mobile'
        })
        .when('/policies', {
            title: 'Booking Process - Term & Condition',
            controller: 'policyController',
            templateUrl: '/front-booking/mobile-views/policies?device=mobile'
        })
        .when('/property-details', {
            title: 'Booking Process - Property Details',
            controller: 'propertyDetailsController',
            templateUrl: '/front-booking/mobile-views/property-details?device=mobile'
        })
        .when('/cart/edit/room/:id', {
            title: 'Booking Process - Edit Room',
            controller: 'editCartController',
            templateUrl: '/front-booking/mobile-views/room?device=mobile'
        })
        .when('/cart/edit/extra/:roomId/:extraId', {
            title: 'Booking Process - Edit Room / Extra',
            controller: 'editCartExtraController',
            templateUrl: '/front-booking/mobile-views/extra?device=mobile'
        })
        .when('/cart/edit/extra/:extraId',{
            title: 'Booking Process - Edit Extra',
            controller: 'editCartExtraController',
            templateUrl: '/front-booking/mobile-views/extra?device=mobile'
        })
        .when('/confirmation', {
            title: 'Confirmation',
            controller: 'confirmationController',
            templateUrl: '/front-booking/get-mobile-confirmation?format=htmlfragment&sid='+session.sid
        })
        .when('/payment-contact', {
            title: 'Payment Contact',
            controller: 'paymentContactController',
            templateUrl: '/front-booking/mobile-views/payment-contact?device=mobile'
        })
        .otherwise('/');
    if(typeof isItemOnly !== 'undefined'){
        if(isItemOnly) {
            $routeProvider
                .when('/', {
                    title: 'Booking Process - Extra List',
                    controller: 'extrasListController',
                    templateUrl: '/front-booking/mobile-views/extras?device=mobile'
                });
        }
    }
    if(typeof isMultiProp !== 'undefined'){
        if(isMultiProp){
            $routeProvider
                .when('/properties', {
                    title: 'Booking Process - Property List',
                    controller: 'multiPropController',
                    templateUrl: '/front-booking/mobile-views/properties?device=mobile'
                });
        }
    }
});

bookingApp.filter('convert', ['$filter', function () {
    var convertFilter = function (input) {
        var convertedValue = fx(input).to(session.selectedFilters.currency);
        return convertedValue;
    }
    return convertFilter;
}]);

bookingApp.filter('money', ['$filter', function ($filter) {
    var convertFilter = function (input, currencySymbol, thousandSeperator, decimalPoint) {
        currencySymbol = currencySymbol || '$';
        thousandSeperator = thousandSeperator || ',';
        decimalPoint = decimalPoint || '.';
        var convertedValue = $filter('currency')(input, currencySymbol);

        // replace with thousand seperators
        var decimalPointAt = convertedValue.indexOf('.'); // this will only be the one occurence
        convertedValue = convertedValue.replace(',', thousandSeperator);

        // replace the decimal point
        String.prototype.replaceAt = function (index, character) {
            return this.substr(0, index) + character + this.substr(index + character.length);
        }
        convertedValue = convertedValue.replaceAt(decimalPointAt, decimalPoint);

        return convertedValue;
    }
    return convertFilter;
}]);

// Setup "HostedPaymentManager" as a service
bookingApp.factory('PaymentManagerFactory', function () {
    return {
        get: function(config) {
            return new HostedPaymentManager(config);
        }
    }
});


// setup base service
bookingApp.factory('appFactory', function () {
    var app = {};
    app.controls = {};
    app.controls.type = 'full';
    return app;
})
/**
 * Custom submit directive that will only submit when all the validation has passed
 * for all the fields. This extends on the ng-submit directive provided by AngularJS.
 *
 * This directive will also remove the 'pristine' flag from all the fields when
 * hitting submit, allowing the form to display no errors until the submit button
 * is clicked/enter is pressed.
 *
 * The variable 'app' is the instance of a module.
 * E.g. var app = angular.module('my-app', []);
 */
    .directive('customSubmit', function (sessionFactory, $http) {
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                var $element = angular.element(element);

                // Add novalidate to the form element.
                attributes.$set('novalidate', 'novalidate');

                $element.bind('submit', function (e) {

                    e.preventDefault();

                    // Remove the class pristine from all form elements.
                    $element.find('.ng-pristine').removeClass('ng-pristine');

                    // Get the form object.
                    var form = scope[attributes.name];

                    // Set all the fields to dirty and apply the changes on the scope so that
                    // validation errors are shown on submit only.
                    angular.forEach(form, function (formElement, fieldName) {
                        // If the field name starts with a '$' sign, it means it's an Angular
                        // property or function. Skip those items.
                        if (fieldName[0] === '$') return;

                        formElement.$pristine = false;
                        formElement.$dirty = true;
                    });

                    // Do not continue if the form is invalid.
                    if (form.$invalid) {
                        // Focus on the first field that is invalid.
                        $element.find('.ng-invalid').first().focus();

                        return false;
                    }

                    // From this point and below, we can assume that the form is valid.
                    scope.$eval(attributes.customSubmit);
                    scope.$apply();
                });
            }
        };
    });
